angular
  .module('capability-ng-scheduler')
  .controller(
    'studentAvailabilityController',
    function (
      $scope,
      $q,
      loadStudentAvailabilityCommand,
      deleteStudentAvailabilityCommand,
      saveStudentAvailabilityCommand
    ) {
      $scope.flags = {
        hasBeenUpdated: false
      };

      $scope.models = {
        times: undefined,
        preserveTimes: undefined
      };

      $scope.whenSaveRequested = $scope.saveTimes = function saveTimes() {
        if (!$scope.flags.hasBeenUpdated) {
          return;
        }

        $q.all(
          _.map(
            $scope.models.preserveTimes,
            function (timeId) {
              return this($scope.termId, timeId);
            },
            deleteStudentAvailabilityCommand
          )
        )
          .then(function () {
            return $q.all(
              _.map(
                $scope.models.times,
                function (time) {
                  return this($scope.termId, time);
                },
                saveStudentAvailabilityCommand
              )
            );
          })
          .finally(function () {
            $scope.flags.hasBeenUpdated = false;
            $scope.models.preserveTimes = _.map($scope.models.times, 'id');
          });
      };

      $scope.whenUpdated = function whenUpdated(times) {
        $scope.flags.hasBeenUpdated = true;
        $scope.models.times = times;
      };

      loadStudentAvailabilityCommand($scope.termId).then(function (times) {
        $scope.flags.hasBeenUpdated = false;
        $scope.models.preserveTimes = _.map(times, 'id');
        $scope.models.times = times;
      });
    }
  )
  .directive('studentAvailability', function studentAvailability(DelegateResponder) {
    return {
      restrict: 'AE',
      replace: false,
      templateUrl: 'capability-ng-scheduler/src/components/student_availability/student_availability.html',
      controller: 'studentAvailabilityController',
      scope: {
        termId: '='
      },
      link: function (scope, element, attrs) {
        element.addClass('student-availability');

        DelegateResponder(scope, {
          attrs: attrs,
          uniqueComponent: 'student-availability',
          vocabulary: {
            save: function () {
              this.saveTimes();
            }
          }
        });
      }
    };
  })
  .service('studentAvailabilityDelegate', function studentAvailabilityDelegate(DelegateController) {
    DelegateController(this, {
      uniqueComponent: 'student-availability',
      vocabulary: {
        save: 'eabui.student-availability.save'
      }
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/student_availability/student_availability.js